<button
  *ngIf="minimized"
  type="button"
  class="cart-fab"
  [style.backgroundColor]="titleBackgroundColor"
  (click)="toggleMinimize($event)"
  aria-label="Abrir carrinho"
>
  <i class="{{ SITE ? SITE.iconCart : '' }}"></i>
  <span class="cart-fab-total">R$ {{ total.toFixed(2).replace(".", ",") }}</span>
  <span class="cart-fab-count">{{ itemCount }}</span>
</button>

<div *ngIf="!minimized" class="cart-content" (click)="this.showCart.emit()" style="height: fit-content">
  <div class="p-2 d-flex justify-content-between align-items-center cart-header">
    <div class="cart-header-side"></div>
    <div class="row align-items-start" style="font-weight: 900">
      <div class="col" style="font-size: 10px" i18n>R$</div>
      <div class="col" style="padding-left: 0.2rem">
        {{ total.toFixed(2).replace(".", ",") }}
      </div>
    </div>
    <div class="cart-header-side">
      <button
        type="button"
        class="cart-minimize"
        [style.backgroundColor]="titleBackgroundColor"
        (click)="toggleMinimize($event)"
        title="Minimizar"
        aria-label="Minimizar carrinho"
      >
        −
      </button>
    </div>
  </div>
  <div class="p-2 row cart-items-box">
    <div class="col-12 cart-items mb-3">
      <div *ngFor="let item of items" class="cart-item mb-2">
        <div class="row no-gutters">
          <div
            class="col-md-4 pr-2"
            (click)="redirectTo('/produto/' + item.produto)"
          >
            <img
              src="{{ imageApiProdutos }}{{
                item.nome ? item.nome : item.imagem
              }}"
              class="card-img cart-item-image img-thumbnail"
              alt="Product Image"
            />
          </div>
          <div
            class="col-md-8 pr-2"
            (click)="redirectTo('/produto/' + item.produto)"
          >
            <p class="card-text">
              <span
                ><b class="cart-item-title"
                  >{{ item.produtoReferencia }} -
                  {{
                    item.descricao ? item.descricao : item.produtoDescricao
                  }}</b
                ></span
              >
            </p>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-5 cart-item-data" i18n>
            Quantidade:
            <span
              ><b class="cart-item-data">{{ item.quantidade }}</b></span
            ><br />
          </div>
          <div class="col-5 cart-item-data">
            <span i18n>
            Total:
          </span>
          <span
            ><b class="cart-item-data" i18n>R${{ item.subtotal | currency : "BRL" : "" }}</b></span
          ><br />
          </div>
          <div class="col-md-2 cart-item-remove d-flex flex-row-reverse">
            <button
              (click)="removeItem(item)"
              title="Excluir"
              class="btn btn-outline-danger cart-item-delet-button"
            >
              <i class="icofont-trash"></i>
            </button>
          </div>
        </div>
        <hr width="100%" />
      </div>
    </div>
  </div>
  <div class="cart-footer">
    <div class="cart-total-row cart-total-muted">
      <span i18n>Subtotal</span>
      <span>{{ total | currency : "BRL" }}</span>
    </div>
    <div class="cart-total-row cart-total-strong">
      <span i18n>Total estimado</span>
      <span class="cart-total-primary" [style.color]="titleBackgroundColor">{{ total | currency : "BRL" }}</span>
    </div>
    <button
      type="button"
      class="cart-finish"
      [style.backgroundColor]="titleBackgroundColor"
      [disabled]="!items.length"
      (click)="redirectTo('/checkout')"
    >
      <span i18n>Finalizar pedido</span>
      <span class="cart-finish-chevron" aria-hidden="true">›</span>
    </button>
  </div>
</div>
